package com.iregained.site.components.sections.home.styles

import com.iregained.site.theme.toSitePalette
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionProperty
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.hover
import com.varabyte.kobweb.silk.style.selectors.link
import com.varabyte.kobweb.silk.style.selectors.visited
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px

val InvertedPrimaryButtonStyle = CssStyle {
    base {
        val palette = colorMode.toSitePalette()
        Modifier.backgroundColor(palette.custom.lightGray) // White background
            .color(palette.brand.primary) // Teal text
            .border(2.px, LineStyle.Solid, palette.custom.lightGray)
            .transition(Transition.of(TransitionProperty.All, duration = 300.ms))
    }
    hover {
        val palette = colorMode.toSitePalette()
        Modifier.backgroundColor(palette.custom.lightGray).translateY((-2).px)
            .boxShadow(0.px, 8.px, 15.px, color = palette.custom.darkText.toRgb().copyf(alpha = 0.3f))
    }
}

val InvertedSecondaryButtonStyle = CssStyle {
    base {
        val palette = colorMode.toSitePalette()
        Modifier
            .backgroundColor(palette.brand.primary)
            .border(2.px, LineStyle.Solid, palette.custom.lightGray)
            .transition(Transition.of(TransitionProperty.All, duration = 300.ms))
            // Force wrapper text color
            .styleModifier { property("color", "${palette.custom.lightGray} !important") }
    }

    // Absolutely force every single child element to obey this text color, crushing inline styles
    cssRule(" *") {
        Modifier.styleModifier {
            property("color", "${colorMode.toSitePalette().custom.lightGray} !important")
        }
    }

    hover {
        val palette = colorMode.toSitePalette()
        Modifier
            .backgroundColor(palette.custom.lightGray)
            .translateY((-2).px)
            .styleModifier { property("color", "${palette.brand.primary} !important") }
    }

    cssRule(":hover *") {
        Modifier.styleModifier {
            property("color", "${colorMode.toSitePalette().brand.primary} !important")
        }
    }
}